import ReactDOM from "react-dom/client";
import React from "react";
import { Currency } from "../../../js/common/CurrencyFormatter";
import elementService from "../../../js/common/ElementService";
import ProductActionPriceInfoModal from "./components/ProductActionPriceInfoModal";
import productDetailInfoService from "./ProductDetailInfoService";
import ProductDetailPageTypeConfig, { ProductDetailInfo } from "./ProductDetailPageTypeConfig";

export default new class ProductActionPriceInfoService {
    public init(pageTypeConfig: ProductDetailPageTypeConfig, currency: Currency): void {
        if (pageTypeConfig.detailType !== "multi") {
            return;
        }

        this.initProductActionPriceModals(pageTypeConfig, currency);
    }

    public showProductActionPriceModal(
        productDetailInfo: ProductDetailInfo,
        actionDiscountCode: string | null,
        megaClearanceSaleDiscountCode: string | null,
        newProductsDiscountCode: string | null,
        currency: Currency,
    ): void {
        const containerElement = document.createElement("div");
        const root = ReactDOM.createRoot(containerElement);

        root.render(<ProductActionPriceInfoModal
            productDetailInfo={productDetailInfo}
            actionDiscountCode={actionDiscountCode}
            megaClearanceSaleDiscountCode={megaClearanceSaleDiscountCode}
            newProductsDiscountCode={newProductsDiscountCode}
            onAfterClose={(): void => {
                root.unmount();
                containerElement.remove();
            }}
            currency={currency}
        />);
    }

    private initProductActionPriceModals(pageTypeConfig: ProductDetailPageTypeConfig, currency: Currency): void {
        for (const actionPriceButton of document.querySelectorAll<HTMLElement>("i[data-action-price-product-id], button[data-action-price-product-id]")) {
            actionPriceButton.addEventListener("click", (event: MouseEvent): void => {
                event.preventDefault();

                const productId = elementService.elementData(actionPriceButton, "actionPriceProductId");

                this.showProductActionPriceModal(
                    this.getProductDetailInfo(pageTypeConfig, Number.parseInt(productId)),
                    pageTypeConfig.actionDiscountCode,
                    pageTypeConfig.megaClearanceSaleDiscountCode,
                    pageTypeConfig.newProductsDiscountCode,
                    currency,
                );
            });
        }
    }

    private getProductDetailInfo(pageTypeConfig: ProductDetailPageTypeConfig, productId: number): ProductDetailInfo {
        return productDetailInfoService.getProductDetailInfo(pageTypeConfig, productId);
    }
}();
